import { Component } from '@angular/core';
import {
	Data, DataLoaderService, Subscription, ResetService, PriceCalculationService, ProgressBarService,
} from '../expert-service-call.index';
import * as _ from 'lodash';
import { Utils } from '../../../../shared/utils';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';
@Component({
	selector: 'expert-package-options',
	templateUrl: './expert-package-options.template.html',
	styleUrls: ['./expert-package-options.component.css']
})
export class ExpertPackageOptions {
	public localOptions: Data[] = [];
	public factoryOptions: Data[] = [];
	public packageOptions: Data[];
	public localPackageOptions: Data[];
	public packageKeyValues: String[] = [];
	public expPackage: Data[] = [];
	public expLocalPackage = [];
	public selected: Data[] = [];
	public standardSelected: Data[] = [];
	public localSelected: Data[] = [];
	public standardLocalSelected: Data[] = [];
	public expertPackageOptions: string;
	public subscription: Subscription;
	private temp: Data[] = [];
	private localTemp: Data[] = [];
	private packageLocalOption;
	private localPackage;
	private localPackageLocalOption;
	public vehicleInfo: any;

	constructor(private dataLoaderService: DataLoaderService, private priceCalculationService: PriceCalculationService,
		private resetService: ResetService, private vehicleInfoService: VehicleInfoService, private progressService: ProgressBarService) {

		this.localOptions = this.dataLoaderService.data.localOptions;
		this.factoryOptions = this.dataLoaderService.data.facOptions;
		this.packageOptions = this.dataLoaderService.data.packages;
		this.localPackageOptions = this.dataLoaderService.data.localPackagesList;
		this.vehicleInfo = this.vehicleInfoService.extractData();
	}

	ngOnInit() {
		if (this.packageOptions.length == 0 && this.localPackageOptions.length == 0) {
			this.dataLoaderService.flagDictionary.noPackagesOptions = true;
		}
		//Retention Service
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalPackage") {
				let tempPackages = [];
				if (selectedOption.data[0] != undefined) {
					this.selected = [];
					this.temp = [];
					for (let i = 0; i < selectedOption.data[0].length; i++) {
						this.selected.push(selectedOption.data[0][i].code);
						this.selected = _.uniqBy(this.selected, function (o) {
							return o;
						});
						this.temp.push(selectedOption.data[0][i]);
						// for undo
						tempPackages.push(selectedOption.data[0][i].code);
						// if (selectedOption.data[0][i].tempStdFlag) {
						// 	this.standardSelected.push(selectedOption.data[0][i].code)
						// }
						// else {
						// 	this.selected.push(selectedOption.data[0][i].code);
						// }
						// this.selected = _.uniqBy(this.selected, function (o) {
						// 	return o;
						// });
						// this.standardSelected = _.uniqBy(this.standardSelected, function (o) {
						// 	return o;
						// });
						// this.temp.push(selectedOption.data[0][i]);
					}
					// for undo
					if(!this.dataLoaderService.flagDictionary.undoActivatedForPackages){
						this.dataLoaderService.previousPackagesExp= tempPackages;
					}
				}
				else{
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForPackages){
						tempPackages=[];
						this.dataLoaderService.previousPackagesExp= [];
					}
				}
			}
		});
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalLocalPackage") {
				let tempLocalPacages = [];
				if (selectedOption.data[0] != undefined) {
					this.localSelected = [];
					this.localTemp = [];
					for (let i = 0; i < selectedOption.data[0].length; i++) {
						this.localSelected.push(selectedOption.data[0][i].code);
						this.localSelected = _.uniqBy(this.localSelected, function (o) {
							return o;
						});
						this.localTemp.push(selectedOption.data[0][i]);
						// for undo
						tempLocalPacages.push(selectedOption.data[0][i].code);
						// if (selectedOption.data[0][i].tempStdFlag) {
						// 	this.standardLocalSelected.push(selectedOption.data[0][i].code)
						// }
						// else {
						// 	this.localSelected.push(selectedOption.data[0][i].code);
						// }
						// this.localSelected = _.uniqBy(this.localSelected, function (o) {
						// 	return o;
						// });
						// this.standardLocalSelected = _.uniqBy(this.standardLocalSelected, function (o) {
						// 	return o;
						// });
						// this.localTemp.push(selectedOption.data[0][i]);
					}
					// for undo
					if(!this.dataLoaderService.flagDictionary.undoActivatedForLocalPackages){
						this.dataLoaderService.previousLocalPackagesExp= tempLocalPacages;
					}
				}
				else{
					this.localSelected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForLocalPackages){
						tempLocalPacages=[];
						this.dataLoaderService.previousLocalPackagesExp= [];
					}
				}
			}
		});

		// for undo alternative option
		// Package option
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertPackage") {
				let tempPackages = [];
				this.selected=[];
				this.temp = [];
				if (selectedOption.data[0] != undefined) {
					for (let i = 0; i < selectedOption.data[0].length; i++) {

						this.selected.push(selectedOption.data[0][i].code);
						this.selected = _.uniqBy(this.selected, function (o) {
							return o;
						});
						this.temp.push(selectedOption.data[0][i]);
						tempPackages.push(selectedOption.data[0][i].code);
					}
					this.dataLoaderService.previousPackagesExp= tempPackages;

				} else {
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForPackages){
						tempPackages=[];
						this.dataLoaderService.previousPackagesExp= [];
					}
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForPackages= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});

		// LocalPackage option
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertLocalPackage") {
				let tempLocalPacages = [];
				this.localSelected=[];
				this.localTemp = [];
				if (selectedOption.data[0] != undefined) {
					for (let i = 0; i < selectedOption.data[0].length; i++) {

						this.localSelected.push(selectedOption.data[0][i].code);
						this.localSelected = _.uniqBy(this.localSelected, function (o) {
							return o;
						});
						this.localTemp.push(selectedOption.data[0][i]);
						tempLocalPacages.push(selectedOption.data[0][i].code);
					}
					this.dataLoaderService.previousLocalPackagesExp= tempLocalPacages;

				} else {
					this.localSelected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForLocalPackages){
						tempLocalPacages=[];
						this.dataLoaderService.previousLocalPackagesExp= [];
					}
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForLocalPackages= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});
		// Undo - End
		//On load
		this.packageOptions.forEach(element => {
			if (element.selected === true) {
				this.expPackage.unshift(element);
			}
		});

		this.localPackageOptions.forEach(element => {
			if (element.selected === true) {
				this.expLocalPackage.unshift(element);
			}
		});
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.expPackage] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.expLocalPackage] });
		// this.priceCalculationService.expertModePriceCalculation();
		this.priceCalculationService.normalModePriceCalculation();


		//Reset Service
		this.subscription = this.resetService.notifyObservable$.subscribe((res) => {
			this.selected = this.resetService.expPackageCodes;
			this.localSelected = this.resetService.expLocalPackageCodes;
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.resetService.expPackage] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.resetService.expLocalPackage] });

			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.resetService.expPackage] });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.resetService.expLocalPackage] });
			this.priceCalculationService.expertModePriceCalculation();

		});
	}

	ngAfterContentChecked() {
		this.packageKeyValues = [];
		for (let index = 0; index < this.packageOptions.length; index++) {
			if (this.packageOptions[index].selected === false) {
				this.packageKeyValues.push(((this.packageOptions[index].code + " - " + this.packageOptions[index].description)));
			}

		}

		for (let index = 0; index < this.localPackageOptions.length; index++) {
			if (this.localPackageOptions[index].selected === false) {
				this.packageKeyValues.push(((this.localPackageOptions[index].code + " - " + this.localPackageOptions[index].description)));
			}

		}


		for (let j = 0; j < this.packageKeyValues.length; j++) {
			for (let i = 0; i < this.selected.length; i++) {

				let item = this.packageKeyValues[j].substring(0, this.packageKeyValues[j].indexOf(' - '));
				let temp = this.selected[i] + "";
				if (item === temp) {

					this.packageKeyValues.splice(Number(j), 1);
				}
			}
		}
	}

	clearOptions() {
		this.expertPackageOptions = null;
	}
	// Set flags to activate undo 
	undoActivate(){
		// for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForPackages= true;
		this.dataLoaderService.flagDictionary.undoActivatedForLocalPackages= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
	}

	//adds selected package option
	onPackageOptionClick(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.undoActivate() //undo activate
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let packageCode;
		packageCode = item.substr(0, 3);
		// this.dataLoaderService.expAdd.push(packageCode);
		this.expPackage = this.temp;
		this.expLocalPackage = this.localTemp;
		let packageFlag = 0;
		let count = 0;
		//Global Packages
		for (let i in this.packageOptions) {
			if (this.packageOptions[i].code == packageCode) {
				for (let j in this.selected) {
					if (packageCode != this.selected[j]) {
						packageFlag = 1;
						count++;
					}
				}
				if (count == this.selected.length) {
					this.dataLoaderService.flagDictionary.expertValidateFlag = true;
					this.dataLoaderService.flagDictionary.expertvalidated = false;
					packageFlag = 1;
					this.selected.push(packageCode);
					this.expPackage.unshift(this.packageOptions[i]);
					this.packageOptions[i].selected = true;
				} else {
					this.packageOptions[i].selected = false;
				}
			}
		}

		if (packageFlag == 1) {

			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.expPackage] });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.expPackage] });
		}

		// Local Packages
		if (packageFlag == 0) {
			count = 0;
			for (let i in this.localPackageOptions) {
				if (this.localPackageOptions[i].code == packageCode) {
					for (let j in this.localSelected) {
						if (packageCode != this.localSelected[j]) {
							count++;
						}
					}
					if (count == this.localSelected.length) {
						this.dataLoaderService.flagDictionary.expertValidateFlag = true;
						this.dataLoaderService.flagDictionary.expertvalidated = false;
						this.localSelected.push(packageCode);
						this.expLocalPackage.unshift(this.localPackageOptions[i]);
						this.localPackageOptions[i].selected = true;

					} else {
						this.localPackageOptions[i].selected = false;
					}
					
				}
			}
			

			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.expLocalPackage] });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.expLocalPackage] });
		}
		this.dataLoaderService.flagDictionary.migrationFlag = false;
		this.priceCalculationService.expertModePriceCalculation();
		

	}

	// Package delete method	
	deleteSelExpPackageOpt(item) {
		this.undoActivate() //undo activate
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let packageCode;
		packageCode = item.substr(0, 3);
		this.expPackage = this.temp;

		for (let i in this.selected) {
			if (this.selected[i] == packageCode) {
				this.selected.splice(Number(i), 1);
			}
		}
		for (let j in this.expPackage) {
			if (this.expPackage[j].code === packageCode) {
				// if (this.expPackage[j].selected) {
				// 	this.dataLoaderService.expertRemovedCodes.push(this.expPackage[j]);
				// }
				this.expPackage.splice(Number(j), 1);
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		let selcFacForRem = [];
		for (let k in this.packageOptions) {
			if (this.packageOptions[k].selected) {
				selcFacForRem.push(this.packageOptions[k]);
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertPackage", data: [selcFacForRem] });
		for (let k in this.packageOptions) {
			if (this.packageOptions[k].code === packageCode) {
				this.packageOptions[k].selected = false;
			}
		}


		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.expPackage] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.expPackage] });

		this.priceCalculationService.expertModePriceCalculation();
		
	}

	//Local Package delete method
	deleteSelExpLocalPackageOpt(item) {
		this.undoActivate() //undo activate
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		let packageCode;
		packageCode = item.substr(0, 3);
		this.expLocalPackage = this.localTemp;
		for (let i in this.localSelected) {
			if (this.localSelected[i] == packageCode) {
				this.localSelected.splice(Number(i), 1);
			}
		}
		for (let j in this.expLocalPackage) {
			if (this.expLocalPackage[j].code === packageCode) {
				// if (this.expLocalPackage[j].selected) {
				// 	this.dataLoaderService.expertRemovedCodes.push(this.expLocalPackage[j]);
				// }
				this.expLocalPackage.splice(Number(j), 1);
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		let selcFacForRem = [];
		for (let k in this.localPackageOptions) {
			if (this.localPackageOptions[k].selected) {
				selcFacForRem.push(this.localPackageOptions[k]);
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertLocalPackage", data: [selcFacForRem] });
		for (let k in this.localPackageOptions) {
			if (this.localPackageOptions[k].code === packageCode) {
				this.localPackageOptions[k].selected = false;
			}
		}

		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.expLocalPackage] });
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.expLocalPackage] });

		this.priceCalculationService.expertModePriceCalculation();
		// this.priceCalculationService.normalModePriceCalculation()
		
	}
	openviewMorePackage() {
		this.dataLoaderService.flagDictionary.viewMoreFlag = true;
		this.dataLoaderService.flagDictionary.factoryFlag = false;
		this.dataLoaderService.flagDictionary.localFlag = false;
		this.dataLoaderService.flagDictionary.packageFlag = true;
	}

	isMarketEG(){
		return Utils.isCountryEG(this.vehicleInfo.orderingMarket);
	}
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-package-options/expert-package-options.component.ts